const ITEMS = ["Visual Phonics, live and virtual", "Guest speaking", "Staff training", "IEP consultation", "Family guidance"];

export const Marquee = () => (
  <div className="bg-teal text-paper overflow-hidden py-4" aria-hidden="true">
    <div className="mq font-display italic text-2xl gap-10 pr-10">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap">
          <span>{t}</span><span className="text-brass not-italic">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export const PageIntro = ({ eyebrow, title, children, testid }) => (
  <section className="bg-cream text-ink" data-testid={testid}>
    <div className="max-w-6xl mx-auto px-6 pt-16 pb-16 md:pt-24 md:pb-20">
      <p className="lbl text-teal fd">{eyebrow}</p>
      <h1 className="mt-6 max-w-4xl"><span className="ln"><span>{title}</span></span></h1>
      {children && <div className="mt-6 max-w-2xl text-slate fd f1">{children}</div>}
    </div>
  </section>
);
